import { render } from "./router-transition.vue?vue&type=template&id=14bab6fa&ts=true"
import script from "./router-transition.vue?vue&type=script&lang=ts"
export * from "./router-transition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.2.37_webpack@5.69.0_@swc+core@1.12.1_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__